<template>
  <div class="overlay-editor-wrapper">
    <div class="panel-top">
      <div class="panel-top-name">{{ $static('order-e.title', 'Редагування замовлення') }}</div>
      <a href="javascript:void(0);" class="back_trigger" @click="close">
        <span class="icon icon-cross"></span>
      </a>
    </div>
    <div class="panel-middle">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.status', 'Статус замовлення:') }}</label>
            <div class="selector-holder">
              <v-select id="input_sort" :options="statusList" :searchable="false" :reduce="c => c.value"
                v-model="selected.status">
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M15.1528 8.22224C15.4213 8.49072 15.4213 8.92602 15.1528 9.19451L11.4861 12.8612C11.2177 13.1297 10.7824 13.1297 10.5139 12.8612L6.84721 9.19451C6.57872 8.92602 6.57872 8.49072 6.84721 8.22224C7.11569 7.95375 7.55099 7.95375 7.81948 8.22224L11 11.4028L14.1805 8.22224C14.449 7.95375 14.8843 7.95375 15.1528 8.22224Z"
                        fill="#212121" />
                    </svg>
                  </span>
                </template>
              </v-select>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.pstatus', 'Статус оплати:') }}</label>
            <div class="selector-holder">
              <v-select id="input_sort" :searchable="false" :options="payStatusList" :reduce="c => c.value"
                v-model="selected.pay_status">
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M15.1528 8.22224C15.4213 8.49072 15.4213 8.92602 15.1528 9.19451L11.4861 12.8612C11.2177 13.1297 10.7824 13.1297 10.5139 12.8612L6.84721 9.19451C6.57872 8.92602 6.57872 8.49072 6.84721 8.22224C7.11569 7.95375 7.55099 7.95375 7.81948 8.22224L11 11.4028L14.1805 8.22224C14.449 7.95375 14.8843 7.95375 15.1528 8.22224Z"
                        fill="#212121" />
                    </svg>
                  </span>
                </template>
              </v-select>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.t3', 'Номер чеку:') }}</label>
            <input type="text" class="form-control custom-input" v-model="selected.check_id">
          </div>
        </div>
      </div>
      <div class="panel-bordered panel order-total-info row " style="background-color:#ffffff">
        <div class="col order-total-info-col">
          <div class="custom-label">{{ $static('order-e.t4', 'Номер замовлення:') }}</div>
          <div class="value">#{{ selected.id }}</div>
        </div>
        <div class="col order-total-info-col">
          <div class="custom-label">{{ $static('order-e.t5', 'Час замовлення:') }}</div>
          <div class="value">{{ selected.created_at.toLocaleDateString() }} <span class="clock">{{
            selected.created_at.toLocaleTimeString() }}</span></div>
        </div>
        <div class="col order-total-info-col">
          <div class="custom-label">{{ $static('order-e.t6', 'Усього:') }}</div>
          <div class="value">{{ selected.total }} {{ $store.getters.symbol }}</div>
        </div>
        <div class="col order-total-info-col" v-if="selected?.info?.bonus_discount">
          <div class="custom-label">{{ $static('order-e.bns', 'Бонуси:') }}</div>
          <div class="value">{{ selected.info.bonus_discount }} {{ $store.getters.symbol }}</div>
          <button @click="bonusBack(selected.id)">Повернути бонуси</button>
        </div>

      </div>
      <div class="row">
        <div class="col">
          <div class="custom-label">{{ $static('order-e.t7', 'Позиції замовлення:') }}</div>
          <ul class="editor-order-list">
            <li class="order-list-item " v-for="(element, index) in selected.info.busked">
              <div class="product-card-top d-flex justify-content-between">
                <div class="product-card_main w-50">
                  <div class="product-card_img bg"
                    :style="{ 'background-image': $filters.backgroundImage(element.preview) }">
                  </div>
                  <div class="product-card__title editor_trigger">{{ element.title }}</div>
                </div>
                <div class="option-item price-item">
                  <div class="name">{{ $static('order-e.t8', 'Ціна:') }}</div>
                  <div class="value" v-if="element.old_price"><strike>{{ $filters.money(element.old_price) }}
                      {{ $store.getters.symbol }}</strike> = {{ $filters.money(element.price) }} {{
                        $store.getters.symbol }}
                  </div>
                  <div class="value" v-else>{{ $filters.money(element.price) }}</div>
                </div>
                <div class="option-item" v-if="element.count">
                  <div class="name">{{ $static('order-e.t9', 'К-сть:') }}</div>
                  <div class="value">{{ element.count }}</div>
                </div>
                <div class="option-item" v-if="element.article">
                  <div class="name">{{ $static('order-e.art', 'Артикуль:') }}</div>
                  <div class="value">{{ element.article }}</div>
                </div>

              </div>
              <div class="options-list">
                <div class="option-list-title">{{ $static('order-e.t111', 'Параметри замовлення:') }}</div>
                <div class="option-list-holder">
                  <div class="option-item " v-for="(op, opIndex) in element.add" :key="opIndex">
                    <div class="name">{{ op.option }}:</div>
                    <div class="value">{{ op.name }} {{ $filters.money(op.price) }}{{ $store.getters.symbol }}</div>
                  </div>
                  <div class="option-item " v-for="(op, opIndex) in element.u_select" :key="opIndex">
                    <div class="name">{{ op.name }}:</div>
                    <div class="value">{{ op.item.name }} {{ $filters.money(op.item.price) }}{{ $store.getters.symbol }}
                    </div>
                  </div>
                </div>
              </div>

            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.e1', 'Телефон:') }}</label>
            <input type="text" class="form-control custom-input" v-model="selected.info.phone">
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.e2', 'email:') }}</label>
            <input type="text" class="form-control custom-input" v-model="selected.info.email">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.e3', 'Ім\'я:') }}</label>
            <input type="text" class="form-control custom-input" v-model="selected.info.name">
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.e4', 'Прізвище:') }}</label>
            <input type="text" class="form-control custom-input" v-model="selected.info.surname">
          </div>
        </div>
        <!--        <div class="col">-->
        <!--          <div class="form-group">-->
        <!--            <label class="custom-label">{{$static('order-e.e5', 'По-батькові:')}}</label>-->
        <!--            <input type="text" class="form-control custom-input" v-model="selected.delivery.middle_name">-->
        <!--          </div>-->
        <!--        </div>-->
      </div>

      <div class="row">
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.e6', 'User ID:') }}</label>
            <div class="user-id-box d-flex align-items-center">
              <div class="input-holder">
                <div class="button-group d-flex">
                  <Popper arrow :content="$static('iconsbtn.delete', 'Видалити')" hover placement="top"
                    style="white-space: nowrap">
                    <button class="btn-icon btn-icon-transparent">
                      <span class="icon icon-cross"></span>
                    </button>
                  </Popper>
                  <Popper arrow :content="$static('iconsbtn.don', 'Виконано')" hover placement="top"
                    style="white-space: nowrap">
                    <button class="btn-icon btn-icon-transparent">
                      <span class="icon icon-double-check"></span>
                    </button>
                  </Popper>

                </div>
                <input type="text" class="rewrite-user-id form-control custom-input" placeholder="308653738">
              </div>
              <div class="default-holder">
                <div class="user-id-prev">
                  <!--                  <span class="avatar bg" style="background-image: url(images/avatar.png);"></span>-->
                  <span class="name" v-if="selected.user && selected.user.telegram">{{ selected.user.telegram.id }} @{{
                    selected.user.telegram.username
                  }}</span>
                </div>
                <!--                <div class="button-group d-flex">-->
                <!--                  <button class="btn-icon btn-icon-transparent">-->
                <!--                    <span class="icon icon-clipboard"></span>-->
                <!--                  </button>-->
                <!--                  <button class="btn-icon btn-icon-transparent user-edit-id">-->
                <!--                    <span class="icon icon-edit"></span>-->
                <!--                  </button>-->
                <!--                </div>-->
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.e7', 'Промокод:') }}</label>
            <input type="text" class="form-control custom-input" v-model="selected.info.promocode" disabled>
          </div>
        </div>
      </div>
      <div class="row mt-1 mb-1" v-if="selected.delivery && selected.delivery.id">
        <div class="col">
          <div class="custom-label">{{ $static('order-e.e8', 'Спосіб доставки:') }}</div>
          <div class="radio-group large-radio-group">
            <div class="default-radio" v-for="(item, index) in deliveryOptions" :key="index">
              <input :id="'delivery_np' + index" name="delivery_type" type="radio" :value="item.id"
                v-model="selected.delivery.id">
              <label :for="'delivery_np' + index">
                <div class="label-content">
                  <div class="logo" v-if="item.manifest && item.manifest.icon">
                    <img :src="item.manifest.icon" :alt="item.name">
                  </div>
                  <div class="name" v-if="item.manifest && item.manifest.name">
                    {{ item.manifest.name }}
                  </div>

                  <div class="name" v-else>
                    {{ item.name }}
                  </div>
                </div>
              </label>
            </div>
            <!--            <div class="default-radio">-->
            <!--              <input id="np_curier" name="delivery_type" type="radio" value="Укрпошта" v-model="selected.delivery.type">-->
            <!--              <label for="np_curier">Укрпошта</label>-->
            <!--            </div>-->
            <!--            <div class="default-radio">-->
            <!--              <input id="np_curier2" name="delivery_type" type="radio" value="Інше" v-model="selected.delivery.type">-->
            <!--              <label for="np_curier2">Інше</label>-->
            <!--            </div>-->

          </div>
        </div>

      </div>
      <div class="row">
        <div class="col">
          <div class="custom-label">{{ $static('order-e.e9', 'Спосіб оплати:') }}</div>
          <div class="radio-group large-radio-group">
            <div class="default-radio" v-for="(item, index) in payments" :key="index">
              <input :id="'pay_card' + index" name="payment_type" type="radio" :value="item.id"
                v-model="selected.info.pay_type">
              <label :for="'pay_card' + index">
                <div class="label-content">
                  <div class="logo" v-if="item.manifest && item.manifest.icon">
                    <img :src="item.manifest.icon" :alt="item.name">
                  </div>
                  <div class="name" v-if="item.manifest && item.manifest.name">
                    {{ item.manifest.name }}
                  </div>

                  <div class="name" v-else>
                    {{ item.name }}
                  </div>
                </div>
              </label>
            </div>
            <!--            <div class="default-radio">-->
            <!--              <input id="pay_money" name="payment_type" type="radio" value="cash" v-model="selected.info.pay_type">-->
            <!--              <label for="pay_money">Наличными</label>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
      <div class="row" v-if="selected.delivery && selected.delivery.id">
        <!--        <div class="col">-->
        <!--          <div class="form-group">-->
        <!--            <label class="custom-label">Страна:</label>-->
        <!--            <div class="selector-holder">-->
        <!--              <select class="select-custom selectpicker" v-model="selected.delivery.country">-->
        <!--                <option selected="selected" value="Украина">Украина</option>-->
        <!--                <option value="Чехия">Чехия</option>-->
        <!--                <option value="Польша">Польша</option>-->
        <!--                <option value="Хорватия">Хорватия</option>-->
        <!--              </select>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.r1', 'Місто:') }}</label>
            <input type="text" class="form-control custom-input" v-model="selected.delivery.city">
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.z4', 'ZIP') }}</label>
            <input type="text" class="form-control custom-input" v-model="selected.delivery.zip">
          </div>
        </div>
      </div>

      <div class="row" v-if="selected.delivery && selected.delivery.id">
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.r2', 'Вулиця:') }}</label>
            <input type="text" class="form-control custom-input" v-model="selected.delivery.address">
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.r3', 'Номер будинку:') }}</label>
            <input type="text" class="form-control custom-input" v-model="selected.delivery.b_number">
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.z2', 'Поверх') }}</label>
            <input type="text" class="form-control custom-input" v-model="selected.delivery.floor">
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.z3', 'Номер квартири') }}</label>
            <input type="text" class="form-control custom-input" v-model="selected.delivery.apartment">
          </div>
        </div>
      </div>
      <div class="row" v-if="selected.delivery && selected.delivery.id">
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.r4', 'Номер поштового відділення:') }}</label>
            <input type="text" class="form-control custom-input" v-model="selected.delivery.warehouse">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.r5', 'Коментар до замовлення:') }}
            </label>
            <textarea class="form-control custom-input" v-model="selected.info.comment"></textarea>
          </div>
        </div>
      </div>

      <template
        v-if="selected.utm_source || selected.utm_content || selected.utm_medium || selected.utm_term || selected.utm_campaign">
        <h3>UTM мітки</h3>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label class="custom-label">utm_source</label>
              <input type="text" class="form-control custom-input" v-model="selected.utm_source" disabled>
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label class="custom-label">utm_content</label>
              <input type="text" class="form-control custom-input" v-model="selected.utm_content" disabled>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label class="custom-label">utm_medium</label>
              <input type="text" class="form-control custom-input" v-model="selected.utm_medium" disabled>
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label class="custom-label">utm_term</label>
              <input type="text" class="form-control custom-input" v-model="selected.utm_term" disabled>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label class="custom-label">utm_campaign</label>
              <input type="text" class="form-control custom-input" v-model="selected.utm_campaign" disabled>
            </div>
          </div>
          <div class="col"></div>
        </div>
      </template>
    </div>
    <!--    <div class="operational-buttons d-flex justify-content-end">-->
    <!--      <button class="btn-icon btn-icon-outline btn-medium">-->
    <!--        <span class="icon icon-print"></span>-->
    <!--      </button>-->
    <!--      <button class="waves-effect waves-light default-btn btn-green">-->
    <!--        <span class="text">Выслать счет</span>-->
    <!--      </button>-->
    <!--    </div>-->
    <div class="panel-bottom">
      <button class="transparent-btn default-btn back_trigger" @click="close">
        <span class="text">{{ $static('order-e.cancel', 'Скасувати') }}</span>
      </button>
      <button class=" default-btn btn-accent" @click="save">
        <span class="text">{{ $static('order-e.save', 'Зберегти зміни') }}</span>
      </button>
      <!--      <button class=" default-btn btn-red">-->
      <!--        <span class="text">{{$static('order-e.del', 'Удалить товар')}}</span>-->
      <!--      </button>-->
    </div>
  </div>
</template>
<script>
import api from '@/api'
import { nextTick } from 'vue'

export default {
  name: 'OrderEditItem',
  props: ['selected'],
  mounted() {
    window.$('.order-editor select.select-custom').selectpicker();
    console.log(this.$props.selected)
  },
  computed: {
    deliveryOptions() {
      return this.$store.getters.deliveryOptions
    },
    payments() {
      return this.$store.getters.payments
    },
    statusList() {
      return this.$store.getters.statusList
    },
    payStatusList() {
      return this.$store.getters.payStatusList
    }
  },
  data() { },
  methods: {
    close() {
      window.$('body').removeClass('is-hidden');
      if (!window.$('body > .client-profile-editor').hasClass('active')) {
        window.$('.back-blur').removeClass('active');
      }
      window.$('body > .order-editor.active').removeClass('active');

    },
    save() {
      let obj = Object.assign({}, this.selected);
      api.put('/api/order', obj).then(response => response.data).then(data => {
        //ToDo: on cancel order - !Make bonusBack.
        this.$emit('save', data);
        if (obj.status === 'cancel' && obj.info?.bonus_discount && obj.info.bonus_discount > 0) {
          this.bonusBack(obj.id)
        }
      });

      window.$('body').removeClass('is-hidden');
      window.$('body > .active').removeClass('active');
    },
    bonusBack(id) {
      api.post('/api/order/bonus_back', { id: id })
        .then(response => response.data)
        .then(data => {
          if (data.order) {
            this.selected.info = data.order.info
            this.$emit('save', data.order);
          }
        });

      // window.$('body').removeClass('is-hidden');
      // window.$('body > .active').removeClass('active');
    }

  },
  watch: {
    'selected.id': (val) => {
      // console.log('new id', val);
      window.$('.order-editor select.select-custom').selectpicker('destroy');
      setInterval(() => { window.$('.order-editor select.select-custom').selectpicker(); }, 100);
      // nextTick(() => {
      // });
    }
  }
}
</script>
